
export const SUPPORTED_COLLECTIONS = ['whatifreward', 'idaretodream', 'waxstation21', 'syndicates21', 'pixeljourney', 'cleanupcentr', 'pantheon', 'alien.worlds', 'planetdefnft', 'futuresrelic', 'facings', 'mlb.topps', 'taco', 'pigmentiawax', 'wedare2dream'];

// Special Emblem template IDs — equip-only, cannot be staked for MP
// Send to whatifdragon with memo "equip:emblem" to equip
export const EMBLEM_TEMPLATES = new Set([873626, 886849, 886848, 886850, 910069, 910070, 910068]);
// Note: Gold emblem template ID not yet assigned
// 873626 = Phoenix, 886849 = Silver, 886848 = Bronze, 886850 = Omniverse Coin
// 910069 / 910070 / 910068 = Round 3 reissues of Silver / Bronze / Omniverse

// MP values mirrored exactly from whatifdragon.cpp get_base_rate()
// These are the actual base_mp values stored on-chain as mp_provided
const CONTRACT_MP_RATES = {
  // --- whatifreward collection ---
  // WHATIF Verified Master Keycard (#909865) - Soulbound Keycard granting 5000 Base MP (passive in wallet)
  909865: 5000,
  // Fireman NFTs
  878281: 5400,
  878279: 1800,
  878274: 600,
  878273: 200,
  878270: 75,
  878268: 25,
  // Beast NFTs
  880461: 800,
  880460: 400,
  880456: 200,
  880455: 100,
  880454: 50,
  880453: 25,
  // Beast + WTFWUF NFTs
  881084: 1120,
  881083: 560,
  881082: 280,
  881081: 140,
  881080: 70,
  881079: 35,
  // Ascended Fireman
  884624: 6520,
  884627: 13040,
  // Round 3 (Reforged): 8x the Round 2 NFT each replaces
  910139: 6400,
  910140: 3200,
  910141: 1600,
  910142: 800,
  910143: 400,
  910144: 200,
  910133: 8960,
  910134: 4480,
  910135: 2240,
  910136: 1120,
  910137: 560,
  910138: 280,
  910145: 52160,
  910131: 104320,
  // Points boosters (889137-889142)
  889137: 500,
  889138: 1000,
  889139: 2000,
  889140: 4000,
  889141: 8000,
  889142: 16000,
  // XP boosters (889143-889150)
  889143: 500,
  889144: 1000,
  889147: 2000,
  889148: 4000,
  889149: 8000,
  889150: 16000,
  // NFT boosters (889153-889158)
  889153: 500,
  889154: 1000,
  889155: 2000,
  889156: 4000,
  889157: 8000,
  889158: 16000,
  // Stamina boosters (889078-889083)
  889078: 500,
  889079: 1000,
  889080: 2000,
  889081: 4000,
  889082: 8000,
  889083: 16000,
  // Speed boosters (889048-889053)
  889048: 500,
  889049: 1000,
  889050: 2000,
  889051: 4000,
  889052: 8000,
  889053: 16000,
  // MP Boosters (889015-889047)
  889015: 500,
  889016: 1000,
  889017: 2000,
  889043: 4000,
  889046: 8000,
  889047: 16000,
  // Special Emblems - equip only, no MP when staked
  // 873626, 886849, 886848, 886850 and 910068-910070 are in EMBLEM_TEMPLATES above

  // Deeds
  834331: 50,
  834332: 100,
  834333: 200,
  834345: 400,
  834391: 500,
  818455: 1000,
  818254: 1000,
  811270: 1000,
  818457: 2000,
  818258: 2000,
  811274: 2000,
  818459: 3000,
  818259: 3000,
  811275: 3000,
  818460: 4000,
  818261: 4000,
  811276: 4000,
  818462: 5000,
  818262: 5000,
  811278: 5000,

  // Gang Pass
  899554: 10000,

  // Burnable Emblems
  837486: 50,
  841646: 50,
  870362: 50,
  871245: 50,
  872658: 50,
  872679: 50,
  886383: 50,

  // --- idaretodream collection ---
  882954: 1,
  882955: 2,
  882956: 5,
  882957: 12,
  882958: 29,
  882959: 73,
  // Support schema
  883737: 375,
  883742: 750,
  883745: 1500,
  883749: 3000,
  883753: 6000,
  883758: 12000,
  // Inspiration schema
  883740: 450,
  883743: 900,
  883747: 1800,
  883750: 3600,
  883752: 7200,
  883755: 14400,
  // Encouragement schema
  883741: 26400,
  883744: 52800,
  883748: 105600,
  883751: 211200,
  883754: 422400,
  883756: 844800,
  // Heroes
  884252: 1689600,
  883943: 1704600,
  883944: 1719600,
  883945: 1734600,
  883946: 1749600,
  883947: 1764600,
  883948: 1779600,
  883949: 1794600,
  883950: 1809600,
  883951: 1824600,
  883952: 1839600,
  883953: 1854600,
  883954: 1869600,
  883955: 1884600,
  883956: 1899600,
  883957: 1914600,
  883958: 1929600,
  883959: 1944600,
  883960: 1959600,
  883961: 1974600,
  883962: 1989600,
  883963: 2004600,
  883964: 2019600,
  883965: 2034600,
  883991: 2049600,
  883992: 2064600,
  883993: 2079600,
  883994: 2094600,
  883995: 2109600,

  // --- waxstation21 collection ---
  // extractors - tiered by rarity
  902815: 1000,  // Mk-I "Rustbucket" (Common)
  902989: 1500,  // Mk-II "Badger" (Uncommon)
  902990: 2500,  // Mk-III "Magma" (Rare)
  902991: 5000,  // Mk-IV "Isotope" (Epic)
  902992: 10000, // Mk-V "Void Walker" (Legendary)
  902993: 20000, // Mk-VI "The Singularity" (Mystic)

  // --- syndicates21 collection ---
  // mobsters - tiered by rarity
  905480: 5000,   // The Goon (Common)
  905481: 7500,   // The Enforcer (Uncommon)
  905482: 12500,  // The Soldato (Rare)
  905483: 25000,  // The Capo (Epic)
  905484: 50000,  // The Underboss (Legendary)
  905485: 100000, // The Don (Mystic)
  // turf - tiered by rarity
  905345: 5000,   // Back Alley (Common)
  905346: 7500,   // The Docks (Uncommon)
  905347: 12500,  // Speakeasy (Rare)
  905350: 25000,  // Grand Hotel (Epic)
  905354: 50000,  // The Casino (Legendary)
  905356: 100000, // The District (Mystic)
  // extractors
  905361: 400,
  905362: 400,
  // materials
  905489: 400,
  905490: 400,
  905491: 400,
  // module
  905393: 400,
  905396: 400,
  905399: 400,
  905402: 400,
  905406: 400,
  905409: 400,
  905486: 400,
  905487: 400,
  905488: 400,
  // upgrades
  905427: 400,
  905428: 400,
  905429: 400,
  905478: 400,
  905479: 400,
  // badges
  905426: 400,
  // crates
  905421: 400,
  905422: 400,
  905423: 400,
  905424: 400,
  // automation
  905415: 400,
  905416: 400,
  905417: 400,
  905418: 400,
  905419: 400,
  905420: 400,
  // components
  905371: 400,
  905374: 400,
  905376: 400,
  905380: 400,
  905384: 400,
  905388: 400,
  // artifacts
  905425: 400,
  907964: 400,

  // --- pixeljourney collection ---
  781515: 300,

  // --- cleanupcentr collection ---
  904730: 300,
  904729: 300,
  904728: 300,
  904726: 300,
  901532: 300,
  900922: 300,
  900921: 300,
  900920: 300,
  900884: 300,
  900863: 300,
  900814: 300,
  900813: 300,
  900811: 300,
  900810: 300,
  894798: 300,
  882885: 300,
  856817: 300,

  // --- wedare2dream collection ---
  // metapuzzl
  907874: 1,
  907875: 2,
  907876: 5,
  907877: 12,
  907878: 29,
  907879: 73,
  // Support schema
  907880: 375,
  907881: 750,
  907882: 1500,
  907883: 3000,
  907884: 6000,
  907885: 12000,
  // Inspiration schema
  907886: 450,
  907887: 900,
  907888: 1800,
  907889: 3600,
  907890: 7200,
  907891: 14400,
  // Encouragement schema
  907892: 26400,
  907893: 52800,
  907894: 105600,
  907895: 211200,
  907896: 422400,
  907897: 844800,
  // Heroes
  907907: 1689600,
  907908: 1704600,
  907909: 1719600,
  907910: 1734600,
  907911: 1749600,
  907915: 1764600,
  907916: 1779600,
  907917: 1794600,
  907918: 1809600,
  907919: 1824600,
  907920: 1839600,
  907921: 1854600,
  907922: 1869600,
  907924: 1884600,
  907925: 1899600,
  907926: 1914600,
  907927: 1929600,
  907928: 1944600,
  907929: 1959600,
  907930: 1974600,
  907931: 1989600,
  907932: 2004600,
  907933: 2019600,
  907934: 2034600,
  907935: 2049600,
  907936: 2064600,
  907937: 2079600,
  907938: 2094600,
  907942: 2109600,
};

// Boost percent values mirrored from whatifdragon.cpp get_base_rate()
const CONTRACT_BOOST_RATES = {
  889137: 5, 889138: 12, 889139: 25, 889140: 50, 889141: 100, 889142: 200,
  889143: 5, 889144: 12, 889147: 25, 889148: 50, 889149: 100, 889150: 200,
  889153: 5, 889154: 12, 889155: 25, 889156: 50, 889157: 100, 889158: 200,
  889078: 5, 889079: 12, 889080: 25, 889081: 50, 889082: 100, 889083: 200,
  889048: 5, 889049: 12, 889050: 25, 889051: 50, 889052: 100, 889053: 200,
  889015: 5, 889016: 12, 889017: 25, 889043: 50, 889046: 100, 889047: 200,
};

// Boost type from whatifdragon.cpp get_boost_type()
const CONTRACT_BOOST_TYPES = {
  889137: 'Points', 889138: 'Points', 889139: 'Points', 889140: 'Points', 889141: 'Points', 889142: 'Points',
  889143: 'XP', 889144: 'XP', 889147: 'XP', 889148: 'XP', 889149: 'XP', 889150: 'XP',
  889153: 'NFT', 889154: 'NFT', 889155: 'NFT', 889156: 'NFT', 889157: 'NFT', 889158: 'NFT',
  889078: 'Stamina', 889079: 'Stamina', 889080: 'Stamina', 889081: 'Stamina', 889082: 'Stamina', 889083: 'Stamina',
  889048: 'Speed', 889049: 'Speed', 889050: 'Speed', 889051: 'Speed', 889052: 'Speed', 889053: 'Speed',
  889015: 'Attack', 889016: 'Attack', 889017: 'Attack', 889043: 'Attack', 889046: 'Attack', 889047: 'Attack',
};

// Helper to determine MP and Boosts from an NFT, using contract-accurate values
export const getAssetEcosystemStats = (nft) => {
  if (!nft) return null;

  const templateId = nft.template?.template_id ? Number(nft.template.template_id) : null;
  const collectionName = nft.collection?.collection_name;

  let stats = {
    MP: 0,
    boostType: null,
    boostValue: 0,
    slot: null,
    isAttacker: false,
    isGear: false,
  };

  if (templateId) {
    const contractMP = CONTRACT_MP_RATES[templateId];
    if (contractMP !== undefined) {
      stats.MP = contractMP;
      stats.isAttacker = templateId !== 909865;
      if (templateId === 909865) stats.isHeldBonus = true;
    }

    const boostVal = CONTRACT_BOOST_RATES[templateId];
    const boostType = CONTRACT_BOOST_TYPES[templateId];
    if (boostVal !== undefined && boostType) {
      stats.boostValue = boostVal;
      stats.boostType = boostType;
      stats.isGear = true;
    }
  }

  // Fallback for waxstation21 templates not explicitly listed
  if (collectionName === 'waxstation21' && !stats.isAttacker && !stats.isGear) {
    stats.MP = 350; // contract default for waxstation21
    stats.isAttacker = true;
  }
  // Fallback for syndicates21 templates not explicitly listed
  if (collectionName === 'syndicates21' && !stats.isAttacker && !stats.isGear) {
    stats.MP = 400; // contract default for syndicates21
    stats.isAttacker = true;
  }
  if (collectionName === 'futuresrelic' && !stats.isAttacker && !stats.isGear) {
    stats.MP = 15;
    stats.isAttacker = true;

  } if (collectionName === 'facings' && !stats.isAttacker && !stats.isGear) {
    stats.MP = 250;
    stats.isAttacker = true;
  }

  // Fallback for pantheon templates
  if (collectionName === 'pantheon' && !stats.isAttacker && !stats.isGear) {
    stats.MP = 300;
    stats.isAttacker = true;
  }

  if (collectionName === 'alien.worlds' && !stats.isAttacker && !stats.isGear) {
    stats.MP = 10;
    stats.isAttacker = true;
  }

  if (collectionName === 'planetdefnft' && !stats.isAttacker && !stats.isGear) {
    stats.MP = 300;
    stats.isAttacker = true;
  }

  if (collectionName === 'mlb.topps' && !stats.isAttacker && !stats.isGear) {
    stats.MP = 50;
    stats.isAttacker = true;
  }

  if (collectionName === 'taco' && !stats.isAttacker && !stats.isGear) {
    stats.MP = 100;
    stats.isAttacker = true;
  }

  if (collectionName === 'pigmentiawax' && !stats.isAttacker && !stats.isGear) {
    stats.MP = 300;
    stats.isAttacker = true;
  }

  return stats;
};
